import api from "@/utils/axios";

export const fetchUserReviews = async () => {
  const res = await api.get("/reviews/me");
  return res.data;
};

export const fetchTopReviews = async () => {
  const res = await api.get("/reviews/top");
  return res.data;
};

export const createReview = async (data) => {
  const res = await api.post("/reviews", data);
  return res.data;
};

/**
 * @deprecated Use fetchReviews({ firms: slug }) from @/lib/queries/reviews.
 * Kept temporarily for any remaining callers.
 */
export const fetchFirmReviews = async (firmId, page = 1, limit = 10) => {
  const res = await api.get(
    `/reviews/firm/${firmId}?page=${page}&limit=${limit}`,
  );
  return res.data;
};